// @ts-strict-ignore
import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

interface ChannelDepositProps {
  channelId: string
  channelReference: string
}

const ChannelDeposit = ({ channelId, channelReference }: ChannelDepositProps) => {
  return (
    <>
      {channelId && (
        <DataListItem
          id="channel-id"
          testId="channel-id"
          title={i18next.t('channelDepositId')}
          body={ellipseMiddleText(channelId, 20, 10)}
          copyText={channelId}
        />
      )}
      {channelReference && (
        <DataListItem
          id="channel-reference"
          testId="channel-reference"
          title={i18next.t('channelReference')}
          body={ellipseMiddleText(channelReference, 20, 10)}
          copyText={channelReference}
        />
      )}
    </>
  )
}

export default ChannelDeposit
